import { FormElement, Field, Form } from '@progress/kendo-react-form'
import { FormDropDownList, FormInput, FormTextArea } from 'components'
import SaveButton from 'components/Buttons/SaveButton/SaveButton'
import { DEFAULT_PERMISSION_MESSAGE } from 'core/consts'
import { focusFirstError } from 'core/helpers'
import { useRef } from 'react'
import { Col, Row } from 'react-bootstrap'

interface IProps {
    editable: boolean
    formIsModified: boolean
}

const DealerInformationForm = ({ editable }: IProps) => {

    return (
        <div id='DealerInformationForm'>
            <Form
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='bg-light shadow-sm p-3 border pb-5'>
                            <Row>
                                <Col md={6}><h4>Dealer Information</h4></Col>
                                <Col md={6} className='text-start text-md-end' style={{ alignSelf: 'center' }}>
                                    {/* place right aligned element here if needed */}
                                </Col>
                            </Row>
                            <hr />
                            <Row>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerStatus'
                                        component={FormDropDownList}
                                        label='Status:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerOwner'
                                        component={FormDropDownList}
                                        label='Owner:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealertype'
                                        component={FormDropDownList}
                                        label='Dealer Type:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='companyName'
                                        component={FormInput}
                                        label='Company Name:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerAddress'
                                        component={FormInput}
                                        label='Dealership Address:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='address2'
                                        component={FormInput}
                                        label='Address 2:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerCity'
                                        component={FormInput}
                                        label='City:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerState'
                                        component={FormDropDownList}
                                        label='State:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerZip'
                                        component={FormInput}
                                        label='Zip:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='timeZone'
                                        component={FormDropDownList}
                                        label='Time Zone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerPhone'
                                        component={FormInput}
                                        label='Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerFax'
                                        component={FormInput}
                                        label='Fax:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='tollFreePhone'
                                        component={FormInput}
                                        label='Toll Free Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerMobilePhone'
                                        component={FormInput}
                                        label='Mobile Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerSecondaryPhone'
                                        component={FormInput}
                                        label='Secondary Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerBodyShopPhone'
                                        component={FormInput}
                                        label='Body Shop Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerServicePhone'
                                        component={FormInput}
                                        label='Service Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerDetailingPhone'
                                        component={FormInput}
                                        label='Detailing Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='dealerPartsPhone'
                                        component={FormInput}
                                        label='Parts Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='principalName'
                                        component={FormInput}
                                        label='Principal Name:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='principalEmail'
                                        component={FormInput}
                                        label='Principal Email:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='principalPhone'
                                        component={FormInput}
                                        label='Principal Phone:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='principalContactName'
                                        component={FormInput}
                                        label='Principal Contact Name:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='website'
                                        component={FormInput}
                                        label='Website:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='pin'
                                        component={FormInput}
                                        label='PIN:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='autotraderURL'
                                        component={FormInput}
                                        label='AutoTrader URL:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='carscomURL'
                                        component={FormInput}
                                        label='Cars.com URL:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='cfsURL'
                                        component={FormInput}
                                        label='CarsForSale.com URL:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='wonFromCompetitor'
                                        component={FormDropDownList}
                                        label='Won From Competitor:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='newCars'
                                        component={FormInput}
                                        label='New Cars:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='usedCars'
                                        component={FormInput}
                                        label='Used Cars:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col lg={4} md={6}>
                                    <Field
                                        name='originalSalesperson'
                                        component={FormDropDownList}
                                        label='Original Salesperson:'
                                        disabled={!editable}
                                    />
                                </Col>
                                <Col xs={12}>
                                    <Field
                                        name='accountAccessNotes'
                                        component={FormTextArea}
                                        label='Account Access Notes:'
                                        rows='5'
                                        disabled={!editable}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <Row className='my-4'>
                            <Col xs={12} sm={4}>
                                <SaveButton
                                    title={!editable ? DEFAULT_PERMISSION_MESSAGE : undefined}
                                    onClick={() => focusFirstError(formRenderProps)}
                                    type='submit' />
                            </Col>
                        </Row>

                    </FormElement>

                )
                }
            />
        </div>
    )
}
export default DealerInformationForm

